"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var core_1 = __importStar(require("@gin-betting/core"));
var utils_1 = require("../utils");
var _a = core_1.default.utils, replaceBetslipBetIdInBetslipOddId = _a.replaceBetslipBetIdInBetslipOddId, getIdsFromBetslipOddId = _a.getIdsFromBetslipOddId;
function handleAdoptUnaffectedBetslipOdds(state, action) {
    var unaffectedBetslipOddIds = action.payload.unaffectedBetslipOddIds;
    var firstUnaffectedBetslipOddId = unaffectedBetslipOddIds[0];
    if (!firstUnaffectedBetslipOddId)
        return state;
    var betslipBetId = getIdsFromBetslipOddId(firstUnaffectedBetslipOddId).betslipBetId;
    if (!betslipBetId)
        return state;
    var nextBetslipBets = state.betslipBets, nextBetslipOdds = state.betslipOdds;
    var initialBetslipBet = utils_1.getInitialBetslipBet({
        betslipBets: nextBetslipBets.delete(betslipBetId),
        betslipOdds: nextBetslipOdds,
    });
    var adoptiveBetslipBet = initialBetslipBet || utils_1.createBetslipBet();
    var adoptiveBetslipOdds = unaffectedBetslipOddIds.reduce(function (acc, betslipOddId) {
        var betslipOdd = nextBetslipOdds.get(betslipOddId);
        if (!betslipOdd)
            return acc;
        var newBetslipOddId = replaceBetslipBetIdInBetslipOddId({
            betslipOddId: betslipOddId,
            newBetslipBetId: adoptiveBetslipBet.id,
        });
        var newBetslipOdd = __assign(__assign({}, betslipOdd), { singleStatus: core_1.App.BetslipStatus.INITIAL, id: newBetslipOddId });
        return acc.set(newBetslipOdd.id, newBetslipOdd);
    }, immutable_1.OrderedMap());
    var betslipBet = nextBetslipBets.get(betslipBetId);
    if (betslipBet) {
        var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: betslipBet.betslipOddIds.subtract(unaffectedBetslipOddIds) });
        nextBetslipBets = nextBetslipBets.set(nextBetslipBet.id, nextBetslipBet);
    }
    var nextAdoptiveBetslipBet = __assign(__assign({}, adoptiveBetslipBet), { betslipOddIds: adoptiveBetslipOdds.keySeq().toOrderedSet() });
    nextBetslipBets = nextBetslipBets.set(adoptiveBetslipBet.id, nextAdoptiveBetslipBet);
    nextBetslipOdds = nextBetslipOdds
        .deleteAll(unaffectedBetslipOddIds)
        .merge(adoptiveBetslipOdds);
    return state
        .set('betslipBets', nextBetslipBets)
        .set('betslipOdds', nextBetslipOdds);
}
exports.default = handleAdoptUnaffectedBetslipOdds;
//# sourceMappingURL=handleAdoptUnaffectedBetslipOdds.js.map